"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectToken = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectToken = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectToken, _super);
    function IkeObjectToken() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.className = 'Token';
        _this.actionName = 'token';
        return _this;
    }
    return IkeObjectToken;
}(base_1.IkeRestObject));
exports.IkeObjectToken = IkeObjectToken;
//# sourceMappingURL=token.object.js.map